export const FLEXIBLE_REMUNERATION_TRANSLATIONS = {
  balanceCharge: {
    main: 'global.recharge_balance.main',
    title: 'recharge_balance.define_amount.title',
    inputLabel: 'recharge_balance.define_amount.input_label',
    description: 'rf.recharge_balance.proform_checkbox.description',
    continueButton: 'global.button.continue',
    errorMoreThanZero: 'global.error_hint.number_more_than_0',
    endButton: 'global.button.end'
  },
  transferBalance: {
    main: 'global.transfer_data.main',
    title: 'recharge_balance.send_transfer.title',
    globalHolder: 'global.holder.main',
    globalBank: 'global.bank.main',
    globalIban: 'global.iban.main',
    globalSwift: 'global.swift.main',
    infoTitle: 'recharge_balance.send_transfer.tip.title',
    infoDescription: 'recharge_balance.send_transfer.tip.description',
    transferData: 'global.transfer_data.main'
  },
  balanceModal: {
    title: 'global.registered_request.main',
    description: 'rf.recharge_balance.proform_dialog_success.description',
    button: 'button.understood'
  },
  balanceToastSuccess: {
    title: 'global.recharge_balance.main',
    description: 'global.send_transfer.toast_success.description'
  },
  copyData: {
    title: 'copy_data.toast.success'
  }
};
